import { useEffect, useLayoutEffect, useState } from 'react';
import mark from '@/assets/dashboard/seo-signals-mark.svg';
import '@fontsource/space-grotesk/latin-500.css';
import '@fontsource/space-grotesk/latin-600.css';
import '@fontsource/geist/latin-400.css';
import '@fontsource/geist/latin-500.css';
import '@fontsource/geist/latin-600.css';
import '@fontsource/geist-mono/latin-500.css';
import './dashboard.css';

export function useDashboardTheme() {
  const [choice, setChoice] = useState(() => {
    try { const saved = localStorage.getItem('ss-dashboard-theme'); return ['light', 'dark'].includes(saved) ? saved : 'system'; } catch { return 'system'; }
  });
  const [systemDark, setSystemDark] = useState(() => window.matchMedia('(prefers-color-scheme: dark)').matches);
  useEffect(() => {
    const media = window.matchMedia('(prefers-color-scheme: dark)');
    const update = () => setSystemDark(media.matches);
    media.addEventListener('change', update);
    return () => media.removeEventListener('change', update);
  }, []);
  const theme = choice === 'system' ? systemDark ? 'dark' : 'light' : choice;
  useLayoutEffect(() => {
    // Body scope includes Radix portals. Cleanup protects the public homepage.
    document.body.dataset.dashboardTheme = theme;
    return () => { delete document.body.dataset.dashboardTheme; };
  }, [theme]);
  return { choice, theme, setChoice: next => { setChoice(next); try { localStorage.setItem('ss-dashboard-theme', next); } catch { /* Theme still works for this session. */ } } };
}
export function ThemeControl({ choice, setChoice }) {
  return <div className="ss-theme" role="group" aria-label="Dashboard theme">{['light', 'dark', 'system'].map(value => <button type="button" key={value} data-testid={`theme-${value}`} aria-pressed={choice === value} onClick={() => setChoice(value)}>{value[0].toUpperCase() + value.slice(1)}</button>)}</div>;
}
export function DashboardRail({ property, overview, onOverview, onSite, onSetup }) {
  return <aside className="ss-rail">
    <a className="ss-brand" href="#dashboard-main"><img src={mark} width="40" height="40" alt="" />SEO Signals</a>
    <p className="ss-tagline">Fix what matters next.</p>
    <div className="ss-website"><span>Your website</span><strong>{property?.display_name || 'Your connected sites'}</strong></div>
    <nav aria-label="Dashboard sections">
      <button type="button" onClick={onOverview}>All sites</button>
      {[['priorities', 'Priorities'], ['performance', 'Performance'], ['pages', 'Your pages'], ['reports', 'Reports'], ['progress', 'Progress'], ['clarity', 'Clarity'], ['bing', 'Bing'], ['sources', 'Sources']].map(([id, label]) => <a key={id} href={`#${id}`} onClick={overview ? onSite : undefined}>{label}</a>)}
    </nav>
    <div className="ss-rail-foot"><span>Built around your next action.</span><button type="button" onClick={onSetup}>Google setup</button></div>
  </aside>;
}
